var _path, _circle, _circle2, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNuiee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 35,
    viewBox: "0 0 82 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.36963 27.3524V7.75235H5.40163L11.6176 20.0724L11.8416 20.5484H11.8696L11.7296 18.8964V7.75235H15.7896V27.3524H11.7576L5.54163 15.0604L5.28963 14.5844H5.26163L5.40163 16.2364V27.3524H1.36963ZM17.3931 27.3524V7.75235H21.4251V27.3524H17.3931ZM30.3905 27.6324C26.3025 27.6604 22.9985 25.4484 22.9985 20.6884V7.75235H27.0585V19.5404C27.0585 21.9764 28.0945 23.7404 30.3905 23.7404C32.6865 23.7404 33.7505 21.9764 33.7505 19.5404V7.75235H37.8105V20.6884C37.8105 25.4484 34.5065 27.6044 30.3905 27.6324ZM39.3774 27.3524V7.75235H49.6814V11.1964H43.4934V15.5364H49.6814V18.7004H43.4934V23.9084H49.6814V27.3524H39.3774ZM50.9985 27.3524V7.75235H61.3025V11.1964H55.1145V15.5364H61.3025V18.7004H55.1145V23.9084H61.3025V27.3524H50.9985Z",
    fill: "#222222"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.0776,
    cy: 11.5214,
    r: 4.22028,
    fill: "#222222"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.3633,
    cy: 11.5214,
    r: 4.22028,
    fill: "#222222"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.0776,
    cy: 22.962,
    r: 4.22028,
    fill: "#222222"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.3633,
    cy: 22.962,
    r: 4.22028,
    fill: "#222222"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuiee);
export default __webpack_public_path__ + "static/media/Nuiee.0d1c8e6b804ccf441f14f32797afbab0.svg";
export { ForwardRef as ReactComponent };